"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var decoratedTheme = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34;
    var MAX_L = _a.MAX_L, MAX_S = _a.MAX_S, MIN_S = _a.MIN_S, MAX_M = _a.MAX_M, MIN_M = _a.MIN_M, MAX_XS = _a.MAX_XS, MAX_XL = _a.MAX_XL, TABLET_MAX = _a.TABLET_MAX, cssPrefix = _a.cssPrefix, MIN_L = _a.MIN_L;
    return ({
        palette: {
            type: 'light',
            primary: {
                dark: "#292929",
                main: "#585858",
                light: "#878787",
                contrastText: "#DDD"
            },
            secondary: {
                main: "#2792F3",
            }
        },
        typography: {
            fontFamily: "Roboto, sans-serif",
            fontSize: 16
        },
        overrides: {
            MuiCssBaseline: {
                "@global": (_b = {
                        "@media print": {
                            "html, body, #__next": {
                                overflow: "initial",
                            },
                            "#scroll-root": {
                                "overflow-y": "initial"
                            }
                        },
                        "@font-face": [{
                                fontFamily: 'Roboto',
                                src: "url(https://fonts.gstatic.com/s/roboto/v27/KFOlCnqEu92Fr1MmSU5fBBc4AMP6lQ.woff2) format('woff2')",
                                unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD",
                                fontDisplay: "block",
                                fontWeight: "normal",
                                fontStyle: "normal",
                            }],
                        ":root": {
                            "--mdc-typography-font-family": "Roboto, sans-serif"
                        },
                        "body": {
                            backgroundColor: '#fff'
                        },
                        "#nprogress .peg": {
                            boxShadow: "0 0 5px #2792F3, 0 0 5px #2792F3",
                            backgroundColor: "#2792F3"
                        }
                    },
                    _b[".search-index ." + cssPrefix + "_hero_title"] = {
                        display: "flex"
                    },
                    _b[".content-index ." + cssPrefix + "_app-bar_search-wrapper"] = {
                        display: "block"
                    },
                    _b[".section-index ." + cssPrefix + "_app-bar_search-wrapper"] = {
                        display: "block"
                    },
                    _b[".search-results-label"] = {
                        fontSize: 24,
                        color: "#2E2E2E",
                        margin: "0",
                        fontWeight: "bold"
                    },
                    _b[".search-results-term"] = {
                        fontSize: 14,
                        color: "#2E2E2E",
                        marginBottom: "0",
                        fontWeight: "normal"
                    },
                    _b),
            },
            MuiInputBase: {
                input: {
                    '&:-webkit-autofill': {
                        WebkitBoxShadow: 'inset 0 0 0px 9999px #fff',
                        WebkitTextFillColor: '#333',
                    },
                },
            }
        },
        layout: (_c = {
                "&.header-fixed": (_d = {
                        marginTop: "8rem",
                        height: "calc(100vh - 8rem)"
                    },
                    _d[MAX_S] = {
                        marginTop: "5rem",
                        height: "calc(100vh - 5rem)",
                    },
                    _d)
            },
            _c["&.section-index , &." + cssPrefix + "_error-page_root"] = (_e = {},
                _e["& ." + cssPrefix + "-portal_hero_nav-popover"] = {
                    display: "none"
                },
                _e["& ." + cssPrefix + "-portal_hero_title"] = {
                    display: "flex"
                },
                _e),
            _c["&.index-root"] = (_f = {},
                _f["& ." + cssPrefix + "_hero_nav-popover"] = {
                    display: "none"
                },
                _f),
            _c["&.section-index"] = (_g = {},
                _g["& ." + cssPrefix + "_hero_title"] = {
                    display: "none"
                },
                _g["& ." + cssPrefix + "_version-selector_button"] = {
                    border: "none"
                },
                _g),
            _c["&.content-index, &.section-index"] = (_h = {},
                _h["& ." + cssPrefix + "_site-groups_root"] = {
                    marginTop: "0"
                },
                _h["& ." + cssPrefix + "_hero_root"] = {
                    display: "none"
                },
                _h),
            _c["&.search"] = (_j = {},
                _j["& ." + cssPrefix + "_hero_root"] = {
                    display: "none"
                },
                _j),
            _c["& ." + cssPrefix + "_site-section-tiles_section-icon, & ." + cssPrefix + "_content_section-icon"] = {
                display: 'none'
            },
            _c),
        layoutHeaderTitle: (_k = {
                display: "flex"
            },
            _k[MIN_S] = {
                flex: "auto",
                width: "100%",
                "& i18n-message": {
                    display: "none"
                },
            },
            _k[MAX_S] = {
                display: "none"
            },
            _k),
        layoutLoginButton: {
            order: 2
        },
        siteSectionTiles: {},
        siteSectionTilesIcon: {
            display: "none"
        },
        siteSectionTextWrapper: {
            flex: 1
        },
        siteSectionTilesLinks: (_l = {
                display: "grid",
                gridAutoRows: "minmax(300px, max-content)",
                gridGap: "1rem",
                padding: "2rem"
            },
            _l[MIN_M] = {
                padding: "2rem 1.5rem",
                gridTemplateColumns: "repeat(3, 1fr)",
            },
            _l[MAX_M] = {
                margin: "0 1rem",
                gridTemplateColumns: "repeat(2, 1fr)",
            },
            _l[MAX_S] = {
                gridTemplateColumns: "repeat(1, 1fr)",
                padding: "2rem  1rem",
            },
            _l.marginTop = "0",
            _l.justifyContent = "center",
            _l.maxWidth = "900px",
            _l.margin = "0 auto",
            _l["& a"] = (_m = {
                    borderRadius: "5px",
                    gridGap: "0.25rem",
                    alignItems: "center",
                    alignContent: "center",
                    overflowWrap: "break-word",
                    textDecoration: "none"
                },
                _m[MAX_L] = {
                    padding: "1rem",
                    gridGap: "0",
                },
                _m[MAX_M] = {
                    padding: "0.5rem",
                },
                _m),
            _l),
        errorPageSiteSectionLinks: (_o = {
                display: "grid",
                gridAutoRows: "minmax(300px, max-content)",
                gridGap: "1rem",
                padding: "2rem"
            },
            _o[MIN_M] = {
                padding: "2rem 1.5rem",
                gridTemplateColumns: "repeat(3, 1fr)",
                margin: "0 auto"
            },
            _o[MAX_M] = {
                margin: "0 1rem",
                padding: "2rem 1rem",
                gridTemplateColumns: "repeat(2, 1fr)",
            },
            _o[MAX_S] = {
                gridTemplateColumns: "repeat(1, 1fr)",
            },
            _o["& a"] = (_p = {
                    gridGap: "0.25rem",
                    alignItems: "center",
                    alignContent: "center",
                    overflowWrap: "break-word",
                    textDecoration: "none",
                    display: "flex",
                    flexBasis: "calc(20% - 2rem)",
                    flexDirection: "column",
                    padding: "2rem",
                    borderRadius: "5px",
                    margin: "0",
                    justifyContent: "flex-start",
                    transition: "all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
                    backgroundColor: "transparent"
                },
                _p[MAX_L] = {
                    padding: "1rem",
                    gridGap: "0",
                    flexBasis: "calc(25% - 2rem)",
                },
                _p[MAX_M] = {
                    width: "300px",
                    height: "300px",
                    padding: "1rem",
                    margin: "0 auto"
                },
                _p),
            _o.marginTop = "0",
            _o.justifyContent = "center",
            _o.maxWidth = "900px",
            _o.margin = "0 auto",
            _o),
        indexSiteSectionContainer: (_q = {
                display: "grid",
                gridAutoRows: "minmax(300px, max-content)",
                gridGap: "1rem",
                padding: "2rem"
            },
            _q[MIN_M] = {
                padding: "2rem 1.5rem",
                gridTemplateColumns: "repeat(3, 1fr)",
                margin: "0 auto"
            },
            _q[MAX_M] = {
                margin: "0 1rem",
                padding: "2rem 1rem",
                gridTemplateColumns: "repeat(2, 1fr)",
            },
            _q[MAX_S] = {
                gridTemplateColumns: "repeat(1, 1fr)",
            },
            _q["& a"] = (_r = {
                    display: "grid",
                    gridTemplateRows: "1fr 1fr",
                    gridGap: "0",
                    justifyContent: "center",
                    alignItems: "center",
                    alignContent: "center",
                    overflowWrap: "break-word",
                    textDecoration: "none"
                },
                _r[MAX_L] = {
                    padding: "1rem",
                    gridGap: "0",
                },
                _r[MAX_M] = {
                    padding: "1rem",
                },
                _r),
            _q.marginTop = "0",
            _q.justifyContent = "center",
            _q.maxWidth = "900px",
            _q.margin = "0 auto",
            _q),
        appBarProps: {
            color: "inherit",
            position: "fixed"
        },
        appBar: {
            alignContent: "center",
            height: "5rem",
            width: "100%",
        },
        hero: (_s = {
                position: "relative",
                height: "auto",
                backgroundPosition: "center",
                backgroundSize: "cover",
                marginBottom: "0",
                opacity: 1,
                alignItems: "center",
                alignContent: "center",
                "& i18n-message": {
                    flex: 1
                },
                "&.index-root, &.section-index, &.content-index, &.search-index, &.error-index": {
                    backgroundImage: "url(https://assets.portal.heretto.com/themes/whitelabel/Geometric-Background.png)",
                },
                borderBottom: "1px solid #ccc"
            },
            _s[MAX_S] = {
                display: "none"
            },
            _s),
        heroSearchWrapper: (_t = {
                height: "2.25rem",
                width: "30rem"
            },
            _t[MAX_S] = {
                display: "none"
            },
            _t),
        heroSearchBox: {
            icon: 'search',
            fontSize: "14px",
            borderRadius: "5px",
            backgroundColor: "#FFF",
            "& .material-icons": {
                color: "#232B40",
                fontSize: "1.25rem",
                marginTop: "0.25rem"
            }
        },
        layoutContainer: {},
        heroTitle: (_u = {
                color: "#fff",
                lineHeight: "4rem",
                marginBottom: "1rem"
            },
            _u[MAX_M] = {
                fontSize: "3rem",
                lineHeight: "3rem",
            },
            _u[MAX_S] = {
                fontSize: "2rem",
                lineHeight: "2rem",
            },
            _u.margin = "0",
            _u.fontWeight = "bold",
            _u.display = "flex",
            _u.justifyContent = "center",
            _u.fontSize = "3rem",
            _u),
        heroTitleWrapper: {
            fontSize: "1.75em",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            opacity: 1,
            justifyContent: "center",
            maxWidth: "1440px",
            margin: "0 auto",
            color: "#FFFFFF",
            padding: "2rem",
            height: "300px"
        },
        appBarSearchIcon: (_v = {
                name: 'search',
                close: 'close',
                color: "#fff"
            },
            _v[MAX_S] = {
                color: "#545454",
                marginLeft: "0",
                marginRight: "1rem"
            },
            _v["& .material-icons"] = {},
            _v[MIN_S] = {
                display: "none",
            },
            _v),
        appBarSearchCollapse: {},
        searchBox: {
            height: "100%",
            color: "#4f4e4c",
            boxShadow: "0px 6px 6px -3px rgba(0,0,0,0.2), 0px 10px 14px 1px rgba(0,0,0,0.14), 0px 4px 18px 3px rgba(0,0,0,0.12)",
        },
        heroSubTitle: (_w = {
                display: "none",
                color: "#fff",
                textAlign: "center",
                fontSize: "1.5rem",
                lineHeight: "1.75rem",
                width: "55%",
                alignSelf: "center"
            },
            _w[MAX_M] = {
                fontSize: "1.25rem",
                lineHeight: "1.5rem"
            },
            _w[MAX_S] = {
                fontSize: "1rem",
                lineHeight: "1.25rem"
            },
            _w),
        appBarHome: {},
        appBarImage: (_x = {
                imageSrc: "https://assets.portal.heretto.com/media/easyDITA-logo.webp",
                height: "70px"
            },
            _x[MAX_M] = {
                width: "auto",
                height: "auto",
                maxHeight: "2.5rem"
            },
            _x[MAX_S] = {
                maxHeight: "2rem"
            },
            _x),
        appBarDrawerHome: (_y = {},
            _y[MAX_S] = {
                justifyContent: "left",
            },
            _y.paddingLeft = "1rem",
            _y),
        appBarDrawerImage: {
            imageSrc: "https://assets.portal.heretto.com/media/easyDITA-logo.webp"
        },
        appBarDrawerHomeImage: {},
        portalTabsProps: {
            indicatorColor: "secondary",
            textColor: "primary",
            TabIndicatorProps: {
                style: {
                    height: "3px"
                }
            },
            scrollButtons: "on",
            variant: "scrollable",
            scrollable: "true"
        },
        portalTabs: (_z = {
                top: "5rem",
                position: "fixed",
                display: "flex",
                backgroundColor: "#fff",
                borderBottom: "1px solid #707070",
                boxShadow: "inset 0px 2px 4px -1px rgb(0 0 0 / 20%), inset 0px 4px 5px 0px rgb(0 0 0 / 14%), inset 0px 1px 10px 0px rgb(0 0 0 / 12%)",
                justifyContent: "center",
                minHeight: "auto",
                height: "3rem",
                left: 0,
                right: 0,
                zIndex: 2,
                flex: "1"
            },
            _z[MAX_S] = {
                display: "none"
            },
            _z["& .mui-tabs_flex-container, .mui-tabs_scroller"] = {
                maxWidth: "1440px",
                flex: 1,
                display: "flex"
            },
            _z),
        appBarNavPopoverWrapper: (_0 = {},
            _0["& ." + cssPrefix + "_portal-popover_trigger"] = {},
            _0[MAX_S] = {
                display: "none",
            },
            _0),
        portalTabsItem: (_1 = {
                flex: "1",
                fontSize: "1rem",
                lineHeight: "1rem",
                margin: "0 1rem"
            },
            _1[MAX_L] = {
                fontSize: "0.75rem",
                margin: "0",
            },
            _1),
        appBarDrawerButton: {},
        appBarToolbar: {
            maxWidth: "1440px",
            margin: "0 auto",
            padding: "0 1rem"
        },
        footerLanguageSelectWrapper: {},
        footer: (_2 = {
                color: "#fff",
                backgroundColor: "rgb(35, 35, 35)",
                background: "initial",
                width: "100%"
            },
            _2[MIN_M] = {
                display: "block",
                position: "relative"
            },
            _2[TABLET_MAX] = {
                padding: "1rem 3.5rem",
            },
            _2[MAX_M] = {
                display: "block"
            },
            _2),
        footerContainer: {
            gridTemplateColumns: "1fr"
        },
        footerRelatedResourcesDescription: {},
        footerRelatedResources: {
            gridTemplateColumns: "1fr 1fr"
        },
        footerLinkContainer: (_3 = {
                gridTemplateColumns: "1fr 1fr 1fr"
            },
            _3[MAX_XS] = {
                gridTemplateColumns: "1fr",
            },
            _3),
        footerLinkItemText: {},
        footerLinkHeader: {
            marginBottom: "1rem"
        },
        footerRelatedResourcesHeader: {
            marginBottom: "1rem"
        },
        footerRelatedResourcesText: {},
        footerSiteNavWrapper: {
            display: "none"
        },
        footerLinkWrapper: {},
        siteSectionHref: {
            padding: "0",
            flexDirection: "row",
            color: "rgb(69, 75, 82)",
            borderRadius: "10px",
        },
        siteSectionText: (_4 = {
                marginBottom: "0.5rem",
                color: "#707070",
                fontSize: "1.5rem",
                marginTop: "0"
            },
            _4[MAX_L] = {
                fontSize: "1.25rem"
            },
            _4[MAX_S] = {
                fontWeight: "normal",
                fontSize: "1rem"
            },
            _4),
        errorPageSiteSectionTitle: {
            marginBottom: "0.5rem",
            color: "#707070",
            fontSize: "1.5rem",
            marginTop: "0",
            fontWeight: "bold",
        },
        errorPageNextStepsMessage: {
            display: "none",
        },
        indexSiteSectionTitle: {
            color: "#707070",
            fontSize: "1.5rem",
            fontWeight: "bold",
            marginTop: "0",
            marginBottom: "0.5rem",
        },
        siteSectionDescription: {
            color: "#707070",
            textAlign: "center",
            fontSize: "1rem"
        },
        indexSiteSectionDescription: {
            color: "#707070",
            textAlign: "center",
            fontSize: "1rem",
        },
        contentPageSiteSectionTitle: {
            fontWeight: "bold",
            color: "#2E2E2E",
            fontSize: "1.125rem",
        },
        indexSiteSectionHeader: {
            display: "none"
        },
        indexSiteSectionLink: (_5 = {
                display: "flex",
                flexBasis: "calc(20% - 2rem)",
                flexDirection: "column",
                alignItems: "center",
                alignContent: "start",
                overflowWrap: "break-word"
            },
            _5[MAX_L] = {
                flexBasis: "calc(25% - 2rem)",
            },
            _5.textDecoration = "none",
            _5.padding = "2rem",
            _5.borderRadius = "5px",
            _5.margin = "0",
            _5.justifyContent = "flex-start",
            _5.transition = "all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
            _5.boxShadow = "0px 4px 20px rgba(0, 0, 0, 0.15)",
            _5.backgroundColor = "transparent",
            _5[MAX_M] = {
                width: "300px",
                height: "300px",
                margin: "0 auto"
            },
            _5),
        siteSectionTilesContainer: (_6 = {
                margin: "1rem 2rem",
                display: "flex",
                flexDirection: "column"
            },
            _6[MAX_S] = {
                alignItems: "left",
                flexDirection: "column",
                border: "none",
                marginBottom: "0px",
                justifyContent: "space-between"
            },
            _6),
        siteGroupsRelatedResources: {
            display: "none"
        },
        showContentsWrapper: {
            "& .material-icons": {
                color: "#333",
            }
        },
        showContentsTitle: (_7 = {},
            _7[MAX_S] = {
                display: "flex",
                padding: "0 0.5rem",
                marginBottom: "0.5rem",
            },
            _7),
        contentPageContainer: (_8 = {
                padding: '0 2rem',
                gridAutoRows: "minmax(100%, min-content)",
                gridTemplateColumns: "315px auto",
                margin: "0 auto",
                maxWidth: "1440px",
                height: "initial"
            },
            _8[MAX_M] = {
                padding: "0.5rem 1rem",
            },
            _8[MAX_S] = {
                padding: "0",
            },
            _8),
        relatedLinks: {
            display: "none"
        },
        relatedLinksListItem: {},
        relatedLinksTitle: {},
        relatedLinksListItemHref: {},
        contentPageChunkedSectionsWrapper: (_9 = {
                display: "inherit",
                maxHeight: "calc(100vh - 28.5rem)",
                overflowY: "auto",
                top: "1rem"
            },
            _9[MIN_L] = {
                position: "sticky",
            },
            _9[MAX_L] = {
                display: "none"
            },
            _9),
        contentPageTocContainer: {
            paddingRight: "0",
            display: "block",
            "& > *": (_10 = {},
                _10[MIN_M] = {
                    backgroundColor: "transparent"
                },
                _10),
            "& > .mui-paper_root": (_11 = {},
                _11[MIN_M] = {
                    position: "sticky",
                    top: "1rem",
                    height: "initial",
                    maxHeight: "100%",
                    overflowY: "auto"
                },
                _11),
        },
        contentPageMain: (_12 = {},
            _12[MIN_M] = {
                gridTemplateColumns: "75% 25%"
            },
            _12),
        contentPageMainContainer: {
            display: "flex",
        },
        contentPageMainWrapper: (_13 = {},
            _13[MIN_M] = {
                borderLeft: "1px solid #333",
                paddingLeft: "2rem",
                paddingTop: "2rem",
            },
            _13[MAX_S] = {
                padding: "0"
            },
            _13["& render-html"] = (_14 = {
                    paddingRight: "2rem",
                    fontSize: "1rem"
                },
                _14[MAX_S] = {
                    paddingRight: "0.5rem",
                },
                _14["& table"] = {
                    width: "100%",
                    textAlign: "left",
                    borderCollapse: "collapse",
                    borderSpacing: "5px",
                    "& thead > tr:last-child": {
                        width: "100%"
                    },
                    "& .table--title-label": {
                        display: "none",
                    },
                    "& th": {
                        backgroundColor: '#f4f4f4'
                    },
                    "& .desc": {
                        display: "block"
                    }
                },
                _14["& td"] = {
                    paddingRight: "1rem"
                },
                _14["& thead, tbody > tr"] = {
                    borderWidth: "0",
                    borderStyle: "none",
                    borderBottomWidth: "1px",
                    borderBottomColor: "rgba(0,0,0, 0.3)",
                    borderBottomStyle: "solid",
                    borderCollapse: "separate",
                    borderSpacing: "1rem",
                },
                _14["& tr, td, th"] = {
                    borderColor: "rgba(0,0,0, 0.3)",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    borderCollapse: "separate",
                    borderSpacing: "5px 5px",
                },
                _14["& pre.prettyprint"] = (_15 = {
                        backgroundColor: "rgba(140,140,140,0.1)",
                        padding: "1rem"
                    },
                    _15[MAX_S] = {
                        padding: "0.5rem",
                    },
                    _15),
                _14["& ul, ol"] = {
                    paddingLeft: '0.5rem',
                    "& > li::before": {
                        display: "inline !important",
                        marginRight: "0.5rem"
                    }
                },
                _14["& ul"] = {
                    paddingLeft: '3rem',
                    listStyleType: "disc",
                },
                _14["& ol"] = (_16 = {
                        paddingLeft: "2.5rem"
                    },
                    _16[MAX_S] = {
                        paddingLeft: "1.5rem"
                    },
                    _16),
                _14["& .note"] = (_17 = {
                        "& .note__title": {
                            fontWeight: "bold"
                        },
                        position: "relative",
                        padding: "1rem 1rem 1rem 1.75rem",
                        margin: "1rem",
                        borderLeft: "5px solid #404040",
                        color: "#404040",
                        backgroundColor: "#dcdcdc"
                    },
                    _17[MAX_S] = {
                        margin: "0",
                    },
                    _17["&::before"] = {
                        position: "absolute",
                        color: "inherit",
                        left: "0.5rem",
                        top: "1.25rem",
                        display: "inline-block",
                        height: "1rem",
                        width: "1rem",
                        content: "''",
                        marginTop: "1px",
                    },
                    _17),
                _14["& .note_note, .note_trouble"] = {
                    "& .note__title": {
                        color: "#09afd6",
                    },
                    backgroundColor: "#29b4d328",
                    borderColor: "#09afd6",
                    "&::before": {
                        backgroundColor: "#09afd6",
                    }
                },
                _14["& .note_attention, .note_caution, .note_warning, .note_danger"] = {
                    "& .note__title": {
                        color: "#d95700",
                    },
                    backgroundColor: "#d9570027",
                    borderColor: "#d95700",
                    "&::before": {
                        backgroundColor: "#d95700",
                    }
                },
                _14["& .note_tip, .note_fastpath"] = {
                    "& .note__title": {
                        color: "#3f6c51",
                    },
                    backgroundColor: "#3f6c512c",
                    borderColor: "#3f6c51",
                    "&::before": {
                        backgroundColor: "#3f6c51",
                    }
                },
                _14["& .note_restriction, .note_remember, .note_important"] = {
                    "& .note__title": {
                        color: "#ffa600",
                    },
                    backgroundColor: "#ffc25131",
                    borderColor: "#ffa600",
                    "&::before": {
                        backgroundColor: "#ffa600",
                    }
                },
                _14["& .note_note"] = {
                    "&::before": {
                        mask: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='MuiSvgIcon-root' focusable='false' viewBox='0 0 24 24' aria-hidden='true' tabindex='-1'%3E%3Cpath d='M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z'%3E%3C/path%3E%3C/svg%3E\")"
                    }
                },
                _14["& .note_caution, .note_warning"] = {
                    "&::before": {
                        mask: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='MuiSvgIcon-root' focusable='false' viewBox='0 0 24 24' aria-hidden='true' tabindex='-1'%3E%3Cpath d='M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z'%3E%3C/path%3E%3C/svg%3E\")"
                    }
                },
                _14["& .note_trouble"] = {
                    "&::before": {
                        mask: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='MuiSvgIcon-root' focusable='false' viewBox='0 0 24 24' aria-hidden='true' tabindex='-1'%3E%3Cpath d='M22.61 18.99l-9.08-9.08c.93-2.34.45-5.1-1.44-7C9.79.61 6.21.4 3.66 2.26L7.5 6.11 6.08 7.52 2.25 3.69C.39 6.23.6 9.82 2.9 12.11c1.86 1.86 4.57 2.35 6.89 1.48l9.11 9.11c.39.39 1.02.39 1.41 0l2.3-2.3c.4-.38.4-1.01 0-1.41zm-3 1.6l-9.46-9.46c-.61.45-1.29.72-2 .82-1.36.2-2.79-.21-3.83-1.25C3.37 9.76 2.93 8.5 3 7.26l3.09 3.09 4.24-4.24-3.09-3.09c1.24-.07 2.49.37 3.44 1.31 1.08 1.08 1.49 2.57 1.24 3.96-.12.71-.42 1.37-.88 1.96l9.45 9.45-.88.89z'%3E%3C/path%3E%3C/svg%3E\")"
                    }
                },
                _14["& .note_tip"] = {
                    "&::before": {
                        mask: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='MuiSvgIcon-root' focusable='false' viewBox='0 0 24 24' aria-hidden='true' tabindex='-1'%3E%3Cpath d='M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z'%3E%3C/path%3E%3C/svg%3E\")"
                    }
                },
                _14["& .note_restriction"] = {
                    "&::before": {
                        mask: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='MuiSvgIcon-root' focusable='false' viewBox='0 0 24 24' aria-hidden='true' tabindex='-1'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z'%3E%3C/path%3E%3C/svg%3E\")"
                    }
                },
                _14["& .note_remember"] = {
                    "&::before": {
                        mask: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='MuiSvgIcon-root' focusable='false' viewBox='0 0 24 24' aria-hidden='true' tabindex='-1'%3E%3Cpath d='M12 2.02c-5.51 0-9.98 4.47-9.98 9.98s4.47 9.98 9.98 9.98 9.98-4.47 9.98-9.98S17.51 2.02 12 2.02zm0 17.96c-4.4 0-7.98-3.58-7.98-7.98S7.6 4.02 12 4.02 19.98 7.6 19.98 12 16.4 19.98 12 19.98zM12.75 5l-4.5 8.5h3.14V19l4.36-8.5h-3z'%3E%3C/path%3E%3C/svg%3E\")"
                    }
                },
                _14["& .note_important"] = {
                    "&::before": {
                        mask: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='MuiSvgIcon-root' focusable='false' viewBox='0 0 24 24' aria-hidden='true' tabindex='-1'%3E%3Cpath d='M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z'%3E%3C/path%3E%3C/svg%3E\")"
                    }
                },
                _14["& .note_fastpath"] = {
                    "&::before": {
                        mask: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='MuiSvgIcon-root' focusable='false' viewBox='0 0 24 24' aria-hidden='true' tabindex='-1'%3E%3Cpath d='M14 8.83L17.17 12 14 15.17V14H6v-4h8V8.83M12 4v4H4v8h8v4l8-8-8-8z'%3E%3C/path%3E%3C/svg%3E\")"
                    }
                },
                _14["& .note_danger, .note_attention"] = {
                    "&::before": {
                        mask: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='MuiSvgIcon-root' focusable='false' viewBox='0 0 24 24' aria-hidden='true' tabindex='-1'%3E%3Cpath d='M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z'%3E%3C/path%3E%3C/svg%3E\")"
                    }
                },
                _14["& h1"] = {
                    fontSize: "2rem"
                },
                _14["& h2"] = {
                    fontSize: "1.625rem"
                },
                _14[MAX_XL] = {
                    "& .title.topictitle1": {
                        fontSize: "2rem"
                    }
                },
                _14["& a"] = {
                    color: "#0DB9E4",
                    textDecoration: "none",
                    '&:hover': {
                        color: "#0DB9E4",
                    },
                    '&:visited': {
                        color: "#0DB9E4",
                    }
                },
                _14["& code, .codeblock"] = {
                    fontSize: "0.875rem",
                    paddingBottom: "0.875rem"
                },
                _14["& .codeblock"] = (_18 = {
                        overflowX: "auto",
                        maxWidth: "700px"
                    },
                    _18[MAX_L] = {
                        maxWidth: "60vw"
                    },
                    _18[MAX_S] = {
                        maxWidth: "70vw"
                    },
                    _18),
                _14["& figure"] = {
                    display: "flex",
                    flexDirection: "column",
                    "& figcaption": {
                        order: 2,
                        marginTop: "0.5rem",
                        fontSize: "1rem",
                        "& .fig--title-label": {
                            fontWeight: "bold"
                        }
                    },
                    "& img": {
                        order: 1,
                        flexFlow: "row nowrap",
                        alignSelf: "flex-start"
                    },
                    "& .desc": {
                        display: "block"
                    }
                },
                _14["& object"] = {
                    maxWidth: "100%"
                },
                _14),
            _13),
        contentPageHeaderBreadcrumb: {},
        siteSectionBreadcrumb: {
            marginLeft: '0.5rem',
            "& svg": {
                color: "#545454",
            },
            "& p": {
                color: "#545454",
                fontSize: "0.75rem",
            },
        },
        landingHeaderBreadcrumb: {
            marginLeft: '0.5rem',
            "& svg": {
                color: "#545454",
            },
            "& p": {
                color: "#545454",
                fontSize: "0.75rem",
            },
        },
        portalBreadcrumb: {
            separator: "arrow_right",
            margin: "0.0625rem 0.125rem !important"
        },
        portalBreadcrumbIcon: {
            color: '#545454',
            fontSize: "1rem !important"
        },
        contentPageShareButton: (_19 = {},
            _19["& ." + cssPrefix + "_portal-popover_wrapper"] = {
                display: "block"
            },
            _19),
        stepLinkIcon: {
            color: "#545454"
        },
        showContents: {
            "& .material-icons": {}
        },
        showContentsIcon: (_20 = {},
            _20[MIN_S] = {
                width: "auto",
                height: "50px",
            },
            _20[MAX_S] = {
                width: "auto",
                height: "50px",
                display: "block"
            },
            _20[MAX_XS] = {
                width: "30px",
                height: "30px",
            },
            _20),
        contentPageTocHeader: (_21 = {
                height: "3.75rem"
            },
            _21[MIN_M] = {
                display: "none",
            },
            _21),
        showContentsSections: {
            display: "none",
        },
        contentPageSiteSectionIconWrapper: {
            marginTop: "0.5rem",
            marginBottom: "0.25rem",
        },
        portalBreadcrumbHref: {
            color: "#545454",
            "& i18n-message": {
                fontSize: "14px"
            }
        },
        metadata: {
            display: "none"
        },
        metadataItem: {},
        metadataLastModified: {
            display: "none"
        },
        simpleTree: {
            color: "#545454",
            fontSize: "0.5rem",
            "& .mui-tree-item_label": {
                paddingLeft: "0"
            }
        },
        simpleTreeItem: {
            "& p": {
                color: "#2E2E2E",
                fontSize: '1rem',
                padding: ".25rem 0 .25rem .25rem"
            },
            "& p:hover": {
                backgroundColor: "#eee",
            },
        },
        simpleTreeItemSelected: {
            "& p": {
                backgroundColor: "#2792F3 !important",
                color: "#FFF !important",
                padding: ".25rem 0 .25rem .25rem",
                fontSize: '1rem'
            }
        },
        appBarSearchBox: (_22 = {
                icon: 'search',
                color: "#4C4C4C",
                fontSize: "14px",
                borderRadius: "5px",
                backgroundColor: "#fff",
                border: "1px solid #CCC",
                "& .material-icons": {
                    color: "#4C4C4C"
                }
            },
            _22[MIN_S] = {
                transform: "none",
                transition: "unset",
                boxShadow: "none",
            },
            _22),
        indexSiteSectionIcon: (_23 = {
                height: "70px",
                width: "auto",
                display: "flex",
                alignSelf: "center",
                justifySelf: "center",
                marginBottom: "0",
                "&> img": {
                    height: "100%",
                }
            },
            _23[MAX_S] = {
                marginTop: "1rem",
            },
            _23[MAX_XS] = {
                marginTop: "0.5rem",
                height: "70px",
                width: "auto",
            },
            _23),
        errorPageSiteSectionIcon: (_24 = {
                height: "70px",
                width: "auto",
                display: "flex",
                alignSelf: "center",
                justifySelf: "center",
                marginBottom: "1rem",
                "&> img": {
                    height: "100%",
                }
            },
            _24[MAX_S] = {
                marginTop: "1rem",
            },
            _24[MAX_XS] = {
                marginTop: "0.5rem",
                height: "70px",
                width: "auto",
            },
            _24),
        navTree: {
            iconCollapse: "remove",
            iconExpand: "add"
        },
        navTreeItemSelected: {
            borderLeft: "none",
            backgroundColor: "#2792F3 !important",
        },
        navTreeItemExpanded: {},
        navTreeIcon: {
            fontSize: "1rem !important",
            marginTop: "0.5rem"
        },
        navTreeItemGroup: {
            marginLeft: "0"
        },
        navTreeItemHover: {
            backgroundColor: "#eee"
        },
        navTreeItemLabel: {
            color: "#2E2E2E",
            paddingLeft: "0",
            padding: "0.25rem",
            marginLeft: "0",
        },
        navTreeItemLabelSelected: {
            color: "#FFF",
        },
        navTreeItem: {
            alignItems: "start",
        },
        contentPageChunkedSectionsTitle: (_25 = {
                color: "#2E2E2E"
            },
            _25[MIN_M] = {
                fontWeight: "bold",
                marginLeft: "1.5rem"
            },
            _25),
        appBarSearchBoxIcon: {
            height: '18px',
            transform: "translate(14px, -2px)",
            color: "rgba(0,0,0,0.7)"
        },
        appBarSearchWrapper: (_26 = {},
            _26[MIN_S] = {
                display: "none",
                "&.content-index, &.section-index": {
                    display: "flex",
                    order: 1,
                    marginRight: "1rem"
                },
            },
            _26),
        siteSectionIconTitleWrapper: {
            margin: "0",
        },
        siteSectionLink: (_27 = {
                textDecoration: "none",
                padding: "2rem",
                borderRadius: "5px",
                margin: "0",
                justifyContent: "flex-start",
                transition: "all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
                backgroundColor: "transparent"
            },
            _27[MAX_M] = {
                width: "300px",
                height: "300px",
                margin: "0 auto"
            },
            _27),
        siteSectionContainer: (_28 = {
                marginTop: "0",
                justifyContent: "center",
                display: "grid",
                gridAutoRows: "minmax(300px, max-content)",
                gridGap: "1rem",
                maxWidth: "900px",
                margin: "0 auto"
            },
            _28[MIN_M] = {
                gridTemplateColumns: "repeat(3, 1fr)",
            },
            _28[MAX_M] = {
                gridTemplateColumns: "repeat(2, 1fr)",
            },
            _28[MAX_S] = {
                gridTemplateColumns: "repeat(1, 1fr)",
            },
            _28),
        siteSectionIcon: (_29 = {
                height: "70px",
                width: "auto",
                display: "flex",
                alignSelf: "center",
                justifySelf: "center",
                marginBottom: "1rem",
                "&> img": {
                    height: "100%",
                }
            },
            _29[MIN_S] = {
                height: "70px"
            },
            _29[MAX_S] = {
                marginTop: "1rem",
            },
            _29[MAX_XS] = {
                marginTop: "0.5rem",
                width: "30px",
                height: "30px"
            },
            _29),
        siteSectionTilesLinksItem: (_30 = {
                textDecoration: "none",
                padding: "2rem",
                borderRadius: "5px",
                margin: "0",
                justifyContent: "flex-start",
                transition: "all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
                backgroundColor: "transparent"
            },
            _30[MAX_M] = {
                width: "300px",
                height: "300px",
                margin: "0 auto"
            },
            _30),
        toc: {},
        footerLinkHeaderImage: (_31 = {
                height: "5rem",
                width: "auto",
                margin: '0 0 1rem 0'
            },
            _31[MAX_S] = {
                height: "5rem",
                width: "auto",
            },
            _31),
        searchBoxInput: {
            color: "#4C4C4C",
            fontSize: "16px"
        },
        searchResultsListCount: (_32 = {},
            _32[MIN_M] = {
                paddingTop: "0",
            },
            _32),
        searchResultBreadcrumbs: {
            order: 1
        },
        searchResultItem: {
            display: "grid"
        },
        searchResultItemHref: {
            color: "#2E2E2E",
            marginBottom: "0.25rem",
        },
        searchResultSubTitle: {
            color: "#2E2E2E",
            order: 2
        },
        searchResultItemHighlights: {
            color: "#2E2E2E",
            order: 3,
            marginBottom: "1rem"
        },
        searchIndexFiltersButton: {
            backgroundColor: "#2792F3",
        },
        searchIndexFiltersTitle: {
            color: "#2E2E2E",
        },
        searchIndexApplyFiltersButton: {
            backgroundColor: "#2792F3",
        },
        searchIndexClearFiltersButton: {
            border: "none",
            color: "#2792F3",
        },
        searchIndexResultsTitle: (_33 = {
                width: "100%"
            },
            _33[MAX_M] = {
                padding: "1rem",
            },
            _33),
        searchResultListCount: (_34 = {
                color: "#2E2E2E",
                padding: "0 0 1rem 0",
                borderBottom: "none"
            },
            _34[MAX_M] = {
                padding: "0 0 1rem 0",
            },
            _34["& p"] = {
                fontWeight: "bold",
                fontSize: "0.875rem"
            },
            _34),
        searchIndexFiltersButtonGroup: {
            paddingBottom: "1rem",
            "& > button": {
                "&:first-child": {
                    borderRadius: "0.25rem",
                },
                "&:last-child": {
                    border: "none",
                    color: "#2792F3",
                },
            }
        },
        contentPageSiteSectionIcon: {
            display: "none"
        },
        contentsSocialIcons: {
            display: "none"
        },
        errorPageSiteSectionDescription: {
            display: "none"
        },
        stepLinks: {
            flex: "0"
        },
        siteSectionAccordion: {
            componentWrapper: "div"
        },
        appBarDrawerRelatedResources: {
            display: "none"
        },
        sectionsFilterWrapper: {
            color: "#2E2E2E",
        }
    });
};
exports.default = decoratedTheme;
//# sourceMappingURL=index.js.map